import './style.css';
import { Link } from 'react-router-dom';

function BudgetButton(){
    return <Link to="/solicitar-presupuesto"><button className="budget-btn">Solicitar presupuesto</button></Link>
}

export default BudgetButton;